import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year', label: '대상년도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear(),
          afterFix: '년',
        }
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["대상년도", "작성일", "임명장첨부"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    if (search.year) {
      conditions.push({key: list.getHead()[0].key, operator: '=', value: search.year})
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    conditions.push(...SearchColumnKeyword.methods.getConditions(nav, 'column', heads));
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "대상년도",
        key: "header.year",
      },
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "구분",
        key: "body.관리감독자정보.구분",
      },
      {
        name: "부서명",
        key: "body.관리감독자정보.구분",
      },
      {
        name: "직무",
        key: "body.관리감독자정보.직무",
      },
      {
        name: "사번",
        key: "body.관리감독자정보.사번",
      },
      {
        name: "직급",
        key: "body.관리감독자정보.직급",
      },
      {
        name: "이름",
        key: "body.관리감독자정보.이름",
      },
      {
        name: "선임일자",
        key: "body.관리감독자정보.선임일자",
      },
      {
        name: "작성일",
        key: "created_at",
      },
    ];
  },
};
export default list;
